import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
  .ButtonsSection_body {
    font-weight: 300;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    @media(min-width: 992px) {
      font-size: 21px;
      line-height: 40px;
    }
    b {
      font-weight: 700;
    }
    a {
      font-weight: 700;
    }
  }
  .container {
    margin: 0 auto;
  }
  .ButtonsSection_title {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    letter-spacing: 2.53px;
    line-height: 25px;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 18px;
      letter-spacing: 2.84px;
      text-align: center;
    }
  }
  .ButtonsSection_wrapper {
  }
  .ButtonsSection_btn {
    position: relative;
    overflow: hidden;
    min-height: 70px;
    padding: 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: ${colors.color1};
    cursor: pointer;
    text-transform: uppercase;
    transition: all .3s ease-out;
    text-align: center;
    @media(min-width: 992px) {
      flex: 1;
      min-height: 90px;
      padding: 20px 35px;
      font-size: 18px;
      letter-spacing: 2.84px;
    }
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: ${colors.color1Darkest};
    }
    &::after {
      content: '';
       position: absolute;
       top: -50%;
       right: 10%;
       bottom: -50%;
       left: 16%;
       background: linear-gradient(to bottom, rgba(0, 144, 210, 0), rgba(140, 205, 235, 0.4) 50%, rgba(0, 144, 210, 0));
       transform: rotateZ(60deg) translate(-5em, 27.5em);
    }
    &:hover::after, &:focus::after {
      animation: sheen 1s forwards;
      right: -95%;
      left: -9%;
    }
    @keyframes sheen {
      100% {
        transform: rotateZ(60deg) translate(1em, -9em);
      }
    }
  }
  .ButtonsSection_btnActive {
    background: transparent;
    border: solid 3px #FFFFFF;
    &:hover {
      color: #FFFFFF;
    }
  }
  .Gold {
    &:focus {
      outline: none;
    }
  }
`;

function ButtonsSection({ option, toggleOptions }) {
  return (
    <div className={styles}>
      <div className="ButtonsSection_wrapper">
        <div className="d-lg-flex">
          <span
            className={`Btn Gold mb-3 mb-lg-0 mr-lg-2 ${option === 'New Construction' ? 'ButtonsSection_btnActive' : ''}`}
            onClick={() => toggleOptions('New Construction')}
            role="button"
            tabIndex={0}
          >
            New Construction
          </span>
          <span
            className={`Btn Gold ml-lg-2 ${option === 'Resale Homes' ? 'ButtonsSection_btnActive' : ''}`}
            onClick={() => toggleOptions('Resale Homes')}
            role="button"
            tabIndex={0}
          >
            Resale Homes
          </span>
        </div>
      </div>
    </div>
  );
}

ButtonsSection.propTypes = {
  option: PropTypes.string.isRequired,
  toggleOptions: PropTypes.func.isRequired,
};

export default ButtonsSection;



// WEBPACK FOOTER //
// ./src/pages/Homes/ButtonsSection.js